export default "/images/vendor/quill/icons/list-check.svg?b70fb56c61cdc4dfdacbc1d7914368a6";